import axios from 'axios'

const api = window.URL_API_TIMELINE

export const byToken = token =>
    axios.get(`${api}timeline/token/${token}`)

export const get = (type, id) =>
    axios.get(`${api}timeline/${type}/${id}`)


export const newPostText = (id, content) => 
    axios.post(`${api}timeline/new_post/${id}`, { content, type: 'text' })


export const newPostFile = (id, data, progress) => {
    var form = new FormData()
    form.append('content', data.content)
    form.append('file', data.file)
    form.append('type', 'file')
    return axios.post(`${api}timeline/new_post/${id}`, form, {
        onUploadProgress: progressEvent => {
            let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            progress(percentCompleted)
        }
    })
}

export const newPostImage = (id, data, progress) => {
    var form = new FormData()
    form.append('content', data.content)
    form.append('image', data.file)
    form.append('type', 'image')
    return axios.post(`${api}timeline/new_post/${id}`, form, {
        onUploadProgress: progressEvent => {
            let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            progress(percentCompleted)
        }
    })
}

export const newPostImages = (id, content) =>
    axios.post(`${api}timeline/new_post/${id}`, { content, type: 'multipleimage' })
    

export const uploadImagePost = (id, data, progress) => {
    var form = new FormData()
    form.append('post_id', id)
    form.append('image', data.file)
    form.append('order', data.order)
    return axios.post(`${api}timeline/upload_image/`, form, {
        onUploadProgress: progressEvent => {
            let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            progress(percentCompleted)
        }
    })
}

export const activePost = (id) =>
    axios.post(`${api}timeline/active_post/${id}`, {})

export const getArticleStarted = (id) =>
    axios.get(`${api}timeline/new_article/${id}`)

export const saveArticle = (id, title, content) =>
    axios.post(`${api}timeline/save_article/${id}`, {title, content})

export const uploadImageArticle = (id, file, progress) => {
    var form = new FormData()
    form.append('image', file)
    return axios.post(`${api}timeline/upload_image_article/${id}`, form, {
        onUploadProgress: progressEvent => {
            let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            progress(percentCompleted)
        }
    })
}

export const publishArticle = (id, title, content) =>
    axios.post(`${api}timeline/publish_article/${id}`, {title, content})

export const loadPosts = (id, start) =>
    axios.get(`${api}timeline/load_posts/${id}/${start}/20`)

export const loadPost = (id) =>
    axios.get(`${api}timeline/post/${id}`)

export const deletePost = (id) =>
    axios.get(`${api}timeline/delete_post/${id}`)

export const approvePost = (id) =>
    axios.get(`${api}timeline/approve_post/${id}`)


// WEBPACK FOOTER //
// ./src/SPRINTA/utils/timeline.js